(function(){'use strict';
var BOTTLE_VARIANT_ID=53551091876134;
var BOTTLE_SKU='SLE-BOTTLE';
var THRESHOLD_CENTS=75000;
var isSyncing=false;
var needsResync=false;
var bottleSoldOut=false;
var reloadArmed=false;

function fetchCart(){
  return fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();});
}
function getBottleLines(cart){
  return cart.items.filter(function(i){return i.variant_id===BOTTLE_VARIANT_ID||i.sku===BOTTLE_SKU;});
}
function qualifyingPreDiscountCents(cart){
  var total=0;
  for(var i=0;i<cart.items.length;i++){
    var item=cart.items[i];
    if(item.variant_id===BOTTLE_VARIANT_ID||item.sku===BOTTLE_SKU){continue;}
    total+=item.original_line_price;
  }
  return total;
}
function addBottle(){
  return fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:BOTTLE_VARIANT_ID,quantity:1,properties:{}}]})}).then(function(r){
    if(!r.ok){bottleSoldOut=true;return null;}
    bottleSoldOut=false;
    return r.json();
  }).catch(function(){bottleSoldOut=true;return null;});
}
function setLineQuantity(line,qty){
  return fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:line.key,quantity:qty})}).then(function(r){
    return r.ok?r.json():null;
  }).catch(function(){return null;});
}
function reconcileBottleLinesSequential(lines,keepQty){
  var p=Promise.resolve(null);
  lines.forEach(function(line,idx){
    var target=idx===0?keepQty:0;
    p=p.then(function(){return setLineQuantity(line,target);});
  });
  return p;
}
function findMount(){
  return document.querySelector('[data-sle-bottle-mount]')||document.querySelector('.cartitems--container')||document.querySelector('.cart__page-col:first-child')||document.querySelector('.cart__page')||null;
}
function findAnchorAfter(){
  return document.querySelector('.cart-title');
}
function renderMessage(cart){
  var qualifyingPre=qualifyingPreDiscountCents(cart);
  
  var bottleLines=getBottleLines(cart);
  var totalBottleQty=bottleLines.reduce(function(s,l){return s+l.quantity;},0);
  var container=document.getElementById('sle-bottle-progress');
  var mount=findMount();
  var anchor=findAnchorAfter();
  if(!mount&&!anchor){return;}
  if(!container){
    container=document.createElement('div');
    container.id='sle-bottle-progress';
    container.setAttribute('style','margin:16px 0;padding:14px 16px;border-radius:4px;font-weight:600;font-size:14px;line-height:1.4;');
    if(mount&&mount.parentNode){mount.parentNode.insertBefore(container,mount);}
    else if(anchor&&anchor.parentNode){anchor.parentNode.insertBefore(container,anchor.nextSibling);}
  }
  if(cart.item_count===0){container.style.display='none';return;}
  container.style.display='block';
  if(qualifyingPre>=THRESHOLD_CENTS&&totalBottleQty>=1){
    container.style.background='#FCAA1F';
    container.style.color='#011A41';
    container.textContent='YOUR FREE $65 SLE BOTTLE IS IN. One per order, while stocks last.';
  } else if(bottleSoldOut){
    container.style.background='#F5F1E8';
    container.style.color='#011A41';
    container.textContent='FREE $65 SLE BOTTLE AT $750 - out of stock right now.';
  } else {
    var remainingCents=THRESHOLD_CENTS-qualifyingPre;
    if(remainingCents<0){remainingCents=0;}
    var remaining=(remainingCents/100).toFixed(2);
    container.style.background='#F5F1E8';
    container.style.color='#011A41';
    container.textContent='FREE $65 SLE BOTTLE AT $750 - you are $'+remaining+' away.';
  }
}
function updateHeaderCount(cart){
  var bubble=document.querySelector('[data-header-cart-count]');
  if(bubble){bubble.textContent=cart.item_count>0?String(cart.item_count):'';}
}
function sync(){
  if(isSyncing){needsResync=true;return Promise.resolve(null);}
  isSyncing=true;
  var mutationOccurred=false;
  return fetchCart().then(function(cart){
    var qualifyingPre=qualifyingPreDiscountCents(cart);
    var bottleLines=getBottleLines(cart);
    var totalBottleQty=bottleLines.reduce(function(s,l){return s+l.quantity;},0);
    var chain=Promise.resolve(null);
    if(qualifyingPre>=THRESHOLD_CENTS){
      if(totalBottleQty===0&&!bottleSoldOut){
        mutationOccurred=true;
        chain=addBottle().then(function(mutatedCart){
          return(mutatedCart?Promise.resolve(mutatedCart):fetchCart()).then(function(freshCart){
            var freshLines=getBottleLines(freshCart);
            if(freshLines.length&&freshLines[0].line_price!==0){
              mutationOccurred=true;
              return setLineQuantity(freshLines[0],0).then(function(){return fetchCart();});
            }
            return freshCart;
          });
        });
      } else if(totalBottleQty>1||bottleLines.length>1){
        mutationOccurred=true;
        chain=reconcileBottleLinesSequential(bottleLines,1).then(function(){return fetchCart();}).then(function(freshCart){
          var freshLines=getBottleLines(freshCart);
          if(freshLines.length&&freshLines[0].line_price!==0){
            mutationOccurred=true;
            return setLineQuantity(freshLines[0],0).then(function(){return fetchCart();});
          }
          return freshCart;
        });
      } else if(bottleLines.length===1&&bottleLines[0].quantity>1){
        mutationOccurred=true;
        chain=setLineQuantity(bottleLines[0],1).then(function(){return fetchCart();}).then(function(freshCart){
          var freshLines=getBottleLines(freshCart);
          if(freshLines.length&&freshLines[0].line_price!==0){
            mutationOccurred=true;
            return setLineQuantity(freshLines[0],0).then(function(){return fetchCart();});
          }
          return freshCart;
        });
      } else if(bottleLines.length===1&&bottleLines[0].line_price!==0){
        mutationOccurred=true;
        chain=setLineQuantity(bottleLines[0],0).then(function(){return fetchCart();});
      }
    } else {
      if(totalBottleQty>0||bottleLines.length>0){
        mutationOccurred=true;
        chain=reconcileBottleLinesSequential(bottleLines,0).then(function(){return fetchCart();});
      }
    }
    return chain.then(function(mc){return mc||fetchCart();});
  }).then(function(finalCart){
    updateHeaderCount(finalCart);
    renderMessage(finalCart);
    if(mutationOccurred&&window.location.pathname.indexOf('/cart')===0&&!reloadArmed){
      reloadArmed=true;
      setTimeout(function(){window.location.reload();},450);
    }
    return finalCart;
  }).catch(function(){return null;}).finally(function(){
    isSyncing=false;
    if(needsResync){needsResync=false;setTimeout(sync,150);}
  });
}
function preCheckoutGuard(){
  return fetchCart().then(function(cart){
    var qualifyingPre=qualifyingPreDiscountCents(cart);
    var bottleLines=getBottleLines(cart);
    var totalBottleQty=bottleLines.reduce(function(s,l){return s+l.quantity;},0);
    if(qualifyingPre>=THRESHOLD_CENTS){
      if(totalBottleQty===0&&!bottleSoldOut){
        return addBottle().then(function(){return fetchCart();}).then(function(freshCart){
          var freshLines=getBottleLines(freshCart);
          if(freshLines.length&&freshLines[0].line_price!==0){
            return setLineQuantity(freshLines[0],0);
          }
          return null;
        });
      }
      if(bottleLines.length>1||totalBottleQty>1){
        return reconcileBottleLinesSequential(bottleLines,1).then(function(){return fetchCart();}).then(function(freshCart){
          var freshLines=getBottleLines(freshCart);
          if(freshLines.length&&freshLines[0].line_price!==0){
            return setLineQuantity(freshLines[0],0);
          }
          return null;
        });
      }
      if(bottleLines.length===1&&bottleLines[0].line_price!==0){
        return setLineQuantity(bottleLines[0],0);
      }
      return null;
    } else {
      if(totalBottleQty>0||bottleLines.length>0){
        return reconcileBottleLinesSequential(bottleLines,0);
      }
      return null;
    }
  }).catch(function(){return null;});
}
if(document.readyState==='loading'){
  document.addEventListener('DOMContentLoaded',sync);
} else {
  sync();
}
var nativeFetch=window.fetch;
window.fetch=function(input,init){
  var url=typeof input==='string'?input:(input&&input.url)||'';
  var isCartMutation=/\/cart\/(add|change|update|clear)(\.js)?/.test(url);
  var result=nativeFetch.apply(this,arguments);
  if(isCartMutation){
    result.then(function(){setTimeout(sync,250);}).catch(function(){});
  }
  return result;
};
document.addEventListener('submit',function(e){
  var form=e.target;
  if(form&&form.getAttribute&&/\/cart/.test(form.getAttribute('action')||'')){
    setTimeout(sync,300);
  }
},true);
document.addEventListener('click',function(e){
  var target=e.target;
  var btn=target&&target.closest?target.closest('button[name="checkout"],input[name="checkout"]'):null;
  if(!btn||btn.__sleGuardPassed){return;}
  var form=btn.form||(btn.closest?btn.closest('form'):null);
  if(!form){return;}
  e.preventDefault();
  e.stopImmediatePropagation();
  var wasDisabled=btn.disabled;
  btn.disabled=true;
  preCheckoutGuard().then(function(){
    btn.__sleGuardPassed=true;
    btn.disabled=wasDisabled;
    if(typeof form.requestSubmit==='function'){form.requestSubmit(btn);}else{form.submit();}
  }).catch(function(){
    btn.__sleGuardPassed=true;
    btn.disabled=wasDisabled;
    if(typeof form.requestSubmit==='function'){form.requestSubmit(btn);}else{form.submit();}
  });
},true);
window.SLEBottleSync=sync;
})();
